module.exports = __webpack_public_path__ + "static/media/kpc-international.72535915.png";